import { render, staticRenderFns } from "./LivingOptionsPackages.vue?vue&type=template&id=1b23cd40&scoped=true&"
import script from "./LivingOptionsPackages.vue?vue&type=script&lang=js&"
export * from "./LivingOptionsPackages.vue?vue&type=script&lang=js&"
import style0 from "./LivingOptionsPackages.vue?vue&type=style&index=0&id=1b23cd40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b23cd40",
  null
  
)

export default component.exports